import { CategoriaNotificacaoLabels, formatDateTime } from '_metronic/helpers'
import { FetchState, useModal } from 'app/components'
import { NotificacaoView } from '../../core/_models'

export const NotificacaoDetalheModal = () => {
  const { fetchStates } = useModal()
  const { data: notificacao } = (fetchStates['notificacao'] || {}) as FetchState<
    NotificacaoView | undefined
  >

  if (!notificacao) return null

  return <NotificacaoDetalheConteudo notificacao={notificacao} />
}

const NotificacaoDetalheConteudo = ({ notificacao }: { notificacao: NotificacaoView }) => (
  <div className='d-flex flex-column gap-5'>
    {notificacao.categoria && (
      <div>
        <div className='fs-8 text-muted'>Categoria</div>
        <div className='fs-6'>{CategoriaNotificacaoLabels[notificacao.categoria]}</div>
      </div>
    )}

    <div>
      <div className='fs-8 text-muted'>Mensagem</div>
      <div className='fs-6'>{notificacao.texto || '-'}</div>
    </div>

    <div className='d-flex gap-8'>
      <div>
        <div className='fs-8 text-muted'>Recebida em</div>
        <div className='fs-7'>{formatDateTime(notificacao.dataInclusao)}</div>
      </div>

      {notificacao.dataLeitura && (
        <div>
          <div className='fs-8 text-muted'>Lida em</div>
          <div className='fs-7'>{formatDateTime(notificacao.dataLeitura)}</div>
        </div>
      )}
    </div>
  </div>
)
